<template>
  <div class="resource-delivery">
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="月份">
                <el-date-picker v-model="searchForm.Month" type="month" placeholder="请选择月份" format="yyyy-MM"
                  value-format="yyyy-MM" clearable style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单号">
                <el-input v-model="searchForm.ticketId" placeholder="请输入工单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="一级机房">
                <el-input v-model="searchForm.idcpName" placeholder="请输入一级机房"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="超时原因">
                <el-select v-model="searchForm.hasLateMemo" placeholder="请选择" clearable style="width: 100%;">
                  <el-option label="有" value="1"></el-option>
                  <el-option label="无" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="操作类型">
                <el-select v-model="searchForm.operationType" placeholder="请选择操作类型" clearable
                  style="width: 100%;">
                  <el-option label="出库" value="出库"></el-option>
                  <el-option label="入库" value="入库"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
                <el-button type="success" plain @click="openBatchExportDialog">批量导出</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <BatchMonthExportDialog
      :visible.sync="showBatchExportDialog"
      :loading="batchExportLoading"
      @confirm="onBatchMonthExportConfirm"
    />
    <div class="title-en">资产账单列表</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button type="primary" @click="openUploadDialog">
            <i class="el-icon-upload"></i> 上传资产账单信息
          </el-button>
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :header-style="{
              'white-space': 'normal',
              'word-break': 'break-all',
              height: 'auto',
              'line-height': '1.2',
              padding: '8px 0',
            }" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                v-if="column.prop === 'num' || column.prop === 'unit_num' || column.prop === 'box_num' || column.prop === 'complete_machine_num' || column.prop === 'wire_num'">{{
                  scope.row[column.prop] || 0 }}</span>
              <el-tag v-else-if="column.prop === 'billType'" :type="scope.row.billType === '1' || scope.row.billType === 1
                  ? 'success'
                  : scope.row.billType === '2' || scope.row.billType === 2
                    ? 'warning'
                    : scope.row.billType === '0' || scope.row.billType === 0
                      ? 'info'
                      : 'danger'
                " size="small">
                {{
                  scope.row.billType === '1' || scope.row.billType === 1
                    ? '全额计费'
                    : scope.row.billType === '2' || scope.row.billType === 2
                      ? '打折计费'
                      : scope.row.billType === '0' || scope.row.billType === 0
                        ? '不计费'
                        : '-'
                }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'isCost'" :type="scope.row.isCost === '是' ? 'success' : 'info'"
                size="small">
                {{ scope.row.isCost || '-' }}
              </el-tag>
              <span v-else-if="column.prop === 'endTime' || column.prop === 'startTime'">{{ scope.row[column.prop]
                ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                : '-'
              }}</span>
              <span v-else-if="column.prop === 'opTicketid'">
                <a :href="scope.row.feedback_status === '已收单'
                    ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                    : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  " target="_blank">{{ scope.row.opTicketid }}</a>
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="600px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <!-- 上传资产账单对话框 -->
        <el-dialog title="上传资产账单信息" :visible.sync="showUploadDialog" :append-to-body="true" width="600px"
          :close-on-click-modal="false" :destroy-on-close="true">
          <el-form :model="uploadForm" label-width="150px" :rules="uploadRules" ref="uploadForm">
            <el-form-item label="所属月份" prop="Month">
              <el-date-picker v-model="uploadForm.Month" type="month" placeholder="请选择月份" format="yyyy-MM"
                value-format="yyyy-MM" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Excel文件" prop="file">
              <el-upload ref="uploadRef" action="#" :auto-upload="false" :on-change="handleFileChange"
                :on-remove="handleFileRemove" :on-exceed="handleFileExceed" :file-list="fileList" 
                accept=".xlsx,.xls" :limit="1" drag class="upload-drag">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div slot="tip" class="el-upload__tip">只能上传 .xlsx/.xls 格式的Excel文件，仅支持单个文件</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showUploadDialog = false">取消</el-button>
            <el-button type="primary" @click="submitUpload" :loading="uploadLoading">上传</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { assetBillList } from '@/api/appManage';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import batchMonthExport from '@/mixins/batchMonthExport';
export default {
  name: 'ResourceDelivery',
  mixins: [batchMonthExport],
  data() {
    // 获取上个月的年月格式
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const lastMonthStr = lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0');

    return {
      debouncedExport: null,
      faults: [],
      searchForm: {
        Month: lastMonthStr,
        orderNo: '',
        ticketId: '',
        idcpName: '',
        operationType: '',
        hasLateMemo: '',
        page: 1,
        size: 10,
      },

      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'ticketId',
        'billType',
        'operationType',
        'complete_machine_num',
        'unit_num',
        'wire_num',
        'box_num',
        'completer',
        'idcpName',
        'Month',
        'lateMemo',
        'opTicketid'
      ],
      defaultSelectedColumns: [
        'ticketId',
        'billType',
        'operationType',
        'complete_machine_num',
        'unit_num',
        'wire_num',
        'box_num',
        'completer',
        'idcpName',
        'Month',
        'lateMemo',
        'opTicketid'
      ],
      columns: [
        { prop: 'ticketId', label: 'Dcops单号（业务工单号）', width: 200 },
        { prop: 'billType', label: '计费权重', width: 100 },
        { prop: 'operationType', label: '操作类型', width: 100 },
        { prop: 'complete_machine_num', label: '整机数量', width: 100 },
        { prop: 'unit_num', label: '部件数量', width: 100 },
        { prop: 'wire_num', label: '线材数量', width: 100 },
        { prop: 'box_num', label: '箱数量', width: 100 },
        { prop: 'completer', label: '结单人', width: 180 },
        { prop: 'idcpName', label: '一级机房', width: 150 },
        { prop: 'Month', label: '所属计费月份', width: 80},
        { prop: 'lateMemo', label: '超时原因', width: 140 },
        { prop: 'opTicketid', label: '关联PO确认单'},


        // { prop: 'ticketId', label: '工作工单号', width: 130 },
        
        { prop: 'id', label: 'ID', width: 80 },
        { prop: 'startTime', label: '工单派单时间', width: 150 },

        { prop: 'costMemo', label: '计费说明', width: 150 },


        { prop: 'opTicketid_cost', label: '关联PO计费单', width: 130 },
        { prop: 'num', label: '资产量', width: 80 },
        { prop: 'endTime', label: '工单结单时间', width: 150 },
        { prop: 'isCost', label: '是否计费', width: 100 },



        { prop: 'serviceName', label: '服务商' },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
      // 上传相关数据
      showUploadDialog: false,
      uploadForm: {
        Month: '',
        file: null,
      },
      uploadRules: {
        Month: [{ required: true, message: '请选择月份', trigger: 'change' }],
        file: [{ required: true, message: '请选择文件', trigger: 'change' }],
      },
      fileList: [],
      uploadLoading: false,
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    async fetchFaultData() {
      const params = {
        Month: this.searchForm.Month,
        orderNo: this.searchForm.orderNo,
        ticketId: this.searchForm.ticketId,
        idcpName: this.searchForm.idcpName,
        operationType: this.searchForm.operationType || undefined,
        hasLateMemo: this.searchForm.hasLateMemo,
        
        page: this.currentPage,
        size: this.pageSize,
      };
      // 过滤掉空值
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });

      this.loading = true;

      try {
        // 使用assetBillList接口进行查询
        const response = await assetBillList(params);
        console.log('======', response);

        if (response.data) {
          let filteredData = response.data.data || [];
          this.faults = filteredData;
          this.total = response.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      // 获取上个月的年月格式
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      const lastMonthStr = lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0');

      this.searchForm = {
        Month: lastMonthStr,
        orderNo: '',
        ticketId: '',
        idcpName: '',
        operationType: '',
        hasLateMemo: '',
        page: 1,
        size: 10,
      };

      this.currentPage = 1;
      this.fetchFaultData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport(options = {}) {
      const { Month_start, Month_end, forceAll } = options || {};
      const isBatchRange = Boolean(Month_start && Month_end);
      this.exportLoading = true;
      try {
        if (forceAll || this.selectedRows.length === 0) {
          // 导出全部数据（含批量月份范围）
          this.loading = true;
          const params = {
            orderNo: this.searchForm.orderNo,
            ticketId: this.searchForm.ticketId,
            idcpName: this.searchForm.idcpName,
            operationType: this.searchForm.operationType || undefined,
            hasLateMemo: this.searchForm.hasLateMemo,
            export_excel: 1
          };
          if (isBatchRange) {
            params.Month_start = Month_start;
            params.Month_end = Month_end;
          } else {
            params.Month = this.searchForm.Month;
          }
          // 过滤掉空值
          Object.keys(params).forEach((key) => {
            if (params[key] === '' || params[key] === null || params[key] === undefined) {
              delete params[key];
            }
          });
          const response = await assetBillList(params);

          if (response.data) {
            this.loading = false;
            const allData = response.data.data || [];
            // 转换数据格式，确保与表格显示一致
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  // 排除操作列
                  let value = row[column.prop];
                  // 特殊字段处理，与表格显示保持一致
                  if (
                    column.prop === 'createTime' ||
                    column.prop === 'completeTime' ||
                    column.prop === 'finishTime' ||
                    column.prop === 'expectFinishTime' ||
                    column.prop === 'billCompleteTime' ||
                    column.prop === 'dispatchCreateTime' ||
                    column.prop === 'dispatchDeskCreateTime' ||
                    column.prop === 'dispatchCompleteTime' ||
                    column.prop === 'dispatchServiceCreateTime' ||
                    column.prop === 'dispatchDeskCompleteTime' ||
                    column.prop === 'billCreateTime'
                  ) {
                    value = row[column.prop]
                      ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                      : '-';
                  } else if (
                    column.prop === 'isDelayCause' ||
                    column.prop === 'isChangeBillNum' ||
                    column.prop === 'isFieldForce' ||
                    column.prop === 'isChange' ||
                    column.prop === 'isChangeBillType' ||
                    column.prop === 'isDispatchCheck' ||
                    column.prop === 'isPo' ||
                    column.prop === 'isTencentCause' ||
                    column.prop === 'is_desk'
                  ) {
                    value = row[column.prop] === '是' || row[column.prop] === 1 || row[column.prop] === '1' ? '是' :
                      row[column.prop] === '否' || row[column.prop] === 0 || row[column.prop] === '0' ? '否' :
                        row[column.prop] || '-';
                  } else if (column.prop === 'billState') {
                    value = row[column.prop] || '-';
                  } else if (column.prop === 'billFactor') {
                    value = row[column.prop] !== null && row[column.prop] !== undefined ? row[column.prop] : '-';
                  } else if (
                    column.prop === 'unit_num' ||
                    column.prop === 'box_num' ||
                    column.prop === 'complete_machine_num' ||
                    column.prop === 'wire_num' ||
                    column.prop === 'num'
                  ) {
                    // 数量类字段：0显示0，null/undefined/空字符串显示'-'
                    value = row[column.prop] === 0 ? 0 : (row[column.prop] || '-');
                  }
                  rowData[column.label] = value !== null && value !== undefined ? value : '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              // 适当加宽导出列，减少 Excel 中出现自动换行两行的情况
              const width = column.width ? Math.ceil(parseInt(column.width, 10) / 5) + 2 : 16;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '资产账单列表');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = isBatchRange
              ? `资产账单列表_${Month_start}_${Month_end}_${timestamp}.xlsx`
              : `资产账单列表_${timestamp}.xlsx`;

            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据的逻辑保持不变
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                // 排除操作列
                let value = row[column.prop];
                // 特殊字段处理，与表格显示保持一致
                if (
                  column.prop === 'createTime' ||
                  column.prop === 'completeTime' ||
                  column.prop === 'finishTime' ||
                  column.prop === 'expectFinishTime' ||
                  column.prop === 'billCompleteTime' ||
                  column.prop === 'dispatchCreateTime' ||
                  column.prop === 'dispatchDeskCreateTime' ||
                  column.prop === 'dispatchCompleteTime' ||
                  column.prop === 'dispatchServiceCreateTime' ||
                  column.prop === 'dispatchDeskCompleteTime' ||
                  column.prop === 'billCreateTime'
                ) {
                  value = row[column.prop]
                    ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-';
                } else if (
                  column.prop === 'isDelayCause' ||
                  column.prop === 'isChangeBillNum' ||
                  column.prop === 'isFieldForce' ||
                  column.prop === 'isChange' ||
                  column.prop === 'isChangeBillType' ||
                  column.prop === 'isDispatchCheck' ||
                  column.prop === 'isPo' ||
                  column.prop === 'isTencentCause' ||
                  column.prop === 'is_desk'
                ) {
                  value = row[column.prop] === '是' || row[column.prop] === 1 || row[column.prop] === '1' ? '是' :
                    row[column.prop] === '否' || row[column.prop] === 0 || row[column.prop] === '0' ? '否' :
                      row[column.prop] || '-';
                } else if (column.prop === 'billState') {
                  value = row[column.prop] || '-';
                } else if (column.prop === 'billFactor') {
                  value = row[column.prop] !== null && row[column.prop] !== undefined ? row[column.prop] : '-';
                } else if (
                  column.prop === 'unit_num' ||
                  column.prop === 'box_num' ||
                  column.prop === 'complete_machine_num' ||
                  column.prop === 'wire_num' ||
                  column.prop === 'num'
                ) {
                  // 数量类字段：0显示0，null/undefined/空字符串显示'-'
                  value = row[column.prop] === 0 ? 0 : (row[column.prop] || '-');
                }
                rowData[column.label] = value !== null && value !== undefined ? value : '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            // 适当加宽导出列，减少 Excel 中出现自动换行两行的情况
            const width = column.width ? Math.ceil(parseInt(column.width, 10) / 5) + 2 : 16;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '资产账单列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `资产账单列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },

    // 上传相关方法
    openUploadDialog() {
      this.showUploadDialog = true;
      this.uploadForm = {
        Month: this.searchForm.Month || '',
        file: null,
      };
      this.fileList = [];
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList;
      this.uploadForm.file = file.raw;
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
      if (fileList.length === 0) {
        this.uploadForm.file = null;
      }
    },
    handleFileExceed(files, fileList) {
      // 超出限制时自动替换为新文件
      this.$refs.uploadRef.clearFiles();
      const file = files[0];
      this.$refs.uploadRef.handleStart(file);
      this.fileList = [{ name: file.name, raw: file, status: 'ready' }];
      this.uploadForm.file = file;
      this.$message.info('已自动替换为新文件');
    },
    async submitUpload() {
      this.$refs.uploadForm.validate(async (valid) => {
        if (!valid) {
          return;
        }

        if (!this.uploadForm.file) {
          this.$message.error('请选择要上传的文件');
          return;
        }

        this.uploadLoading = true;

        try {
          const formData = new FormData();
          formData.append('file', this.uploadForm.file);
          formData.append('Month', this.uploadForm.Month);

          const response = await this.uploadAssetBill(formData);

          if (response.data && response.data.code === 200) {
            this.$message.success(response.data.msg || '上传成功');
            this.showUploadDialog = false;
            // 刷新列表
            this.handleSearch();
          } else {
            this.$message.error(response.data?.msg || '上传失败');
          }
        } catch (error) {
          console.error('上传错误:', error);
          let errorMessage = '上传失败';
          if (error.response && error.response.data && error.response.data.msg) {
            errorMessage = error.response.data.msg;
          }
          this.$message.error(errorMessage);
        } finally {
          this.uploadLoading = false;
        }
      });
    },
    async uploadAssetBill(formData) {
      // 从 appManage 导入 uploadAssetBill
      const { uploadAssetBill } = await import('@/api/appManage');
      return uploadAssetBill(formData);
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.resource-delivery {
  padding: 0;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
  line-height: 1.2;
  padding: 5px 0;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

/* 拖拽上传样式 */
::v-deep .upload-drag .el-upload {
  width: 100%;
}

::v-deep .upload-drag .el-upload-dragger {
  width: 100%;
  height: 120px;
}

::v-deep .upload-drag .el-icon-upload {
  font-size: 40px;
  margin-top: 10px;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>
